<template>
  <div class="essential_information">
    <div class="tabs">
      <span></span>企业信息
      <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
        <i v-show="isEdit" class="tabs_one" @click="goEssentialInformation"></i>
      </el-tooltip>
    </div>
    <el-form v-if="FormDataOne" :inline="true" :label-position="labelPosition" label-width="120px"
      :rules="ruleFormDataOne" ref="ruleFormDataOne" :model="FormDataOne">
      <el-form-item label="企业名称" prop="companyName">
        <el-autocomplete v-model="FormDataOne.companyName" :disabled="isDis" placeholder="请输入企业名称"
          :fetch-suggestions="debounceName" @select="handleSelect" :trigger-on-focus="false"></el-autocomplete>
      </el-form-item>
      <el-form-item label="企业所在地" prop="companyAddress">
        <el-select class="muyu" v-model="FormDataOne.companyAddress" placeholder="请选择企业所在地" :disabled="isDis">
          <el-option v-for="(item) in addressList" :key="item.id" :label="item.dataValue" :value="item.dataValue">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="成立时间" prop="establishTime">
        <el-date-picker type="date" placeholder="选择日期" :disabled="isDis" value-format="yyyy-MM-dd"
          v-model="FormDataOne.establishTime">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="企业官网" prop="companyUrl">
        <el-input v-model="FormDataOne.companyUrl" maxlength="30" :disabled="isDis" placeholder="请输入官网地址"></el-input>
      </el-form-item>
      <el-form-item label="企业类型" prop="companyType">
        <el-select class="muyu" v-model="FormDataOne.companyType" placeholder="请选择" :disabled="isDis">
          <el-option v-for="(item) in companyTypeList" :key="item.val" :label="item.lab" :value="item.val">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="企业规模" prop="companyScale">
        <el-select class="muyu" v-model="FormDataOne.companyScale" placeholder="请选择" :disabled="isDis">
          <el-option v-for="(item) in companyScaleList" :key="item.val" :label="item.lab" :value="item.val">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="翻译领域" prop="domainCode">
        <el-select v-model="FormDataOne.domainCode" placeholder="请选择" :disabled="isDis" @change="handeleDomainCode">
          <el-option v-for="(item) in domainList" :key="item.id" :label="item.dataValue" :value="item.dataValue">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="纳税人识别号" prop="taxpayerId">
        <el-input v-model="FormDataOne.taxpayerId" maxlength="30" :disabled="isDis" placeholder="请输入纳税人识别号"></el-input>
      </el-form-item>
    </el-form>
    <div class="btn" v-if="!isDis">
      <el-button class="cancel" @click="cancel">取消</el-button>
      <el-button class="preservation" @click="preservation">保存</el-button>
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce"; // 防抖函数
import provinceJson from '@/assets/js/provinceJson'
export default {
  props: {
    userInfo: {
      type: Object
    }
  },
  computed: {
    isEdit () {
      if (this.auditStatus === 1) {
        return false
      } else {
        return this.isDis
      }
    },
  },
  watch: {
    userInfo: {
      handler (newVale, oldVale) {
        if (newVale.num === 1) {
          this.id = newVale.id
          this.certificateUrls = newVale.businessLicenseUrls
          this.auditStatus = newVale.auditStatus
          this.FormDataOne.companyName = newVale.companyName;
          this.FormDataOne.companyAddress = newVale.companyAddress;
          this.FormDataOne.establishTime = newVale.establishTime;
          this.FormDataOne.companyUrl = newVale.companyUrl;
          this.FormDataOne.companyType = newVale.companyType;
          this.FormDataOne.companyScale = newVale.companyScale;
          this.FormDataOne.domainCode = newVale.domainName;
          this.FormDataOne.taxpayerId = newVale.taxpayerId;
          this.dataObj = { ...this.FormDataOne } // 解构对象，取消操作用解构对象
        }
      },
      deep: true,
      immediate: true
    },
  },
  data () {
    return {
      certificateUrls: [],
      FormDataOne: {
        companyName: "",
        companyAddress: "",
        establishTime: "",
        companyUrl: "",
        companyType: "",
        companyScale: "",
        domainCode: "",
        taxpayerId: ""
      },
      dataObj: {},
      ruleFormDataOne: {
        companyName: [{ required: true, message: '请输入企业名称', trigger: 'blur' },],
        companyAddress: [{ required: true, message: '请选择企业地址', trigger: 'blur' },],
        taxpayerId: [{ required: true, message: '请输入纳税人识别号', trigger: 'blur' },]
      },
      labelPosition: "left",
      isDis: true,
      id: null,
      auditStatus: null,
      debounceName: "",
      addressList: [],
      companyTypeList: [
        { lab: "事业", val: 1 },
        { lab: "国营", val: 2 },
        { lab: "民营", val: 3 },
        { lab: "其他", val: 4 },
      ],
      companyScaleList: [
        { lab: "0-5", val: 1 },
        { lab: "5-19", val: 2 },
        { lab: "20-99", val: 3 },
        { lab: "100-499", val: 4 },
        { lab: "500-999", val: 5 },
        { lab: "1000以上", val: 6 },
      ],
      domainList: [], //擅长领域
    };
  },
  created () {
    this.queryOptionList();
    this.debounceName = debounce(this.querySearchAsync, 500);
    this.addressList = provinceJson
  },
  methods: {
    // 企业名称模糊查询
    async querySearchAsync (queryString, cb) {
      if (queryString === '' || queryString === null) {
        return
      }
      const { result, success } = await this.catReq1Service("/v1/userRegister/queryCompanyNameList", { name: queryString });
      if (success) {
        result.filter(item => item.value = item.companyName)
        cb(result)
      }
    },
    // 点击企业名称模糊查询事件
    handleSelect (data) {
      this.FormDataOne.taxpayerId = data.identifyNumber
    },
    // 获取领域列表
    queryOptionList () {
      let that = this
      let url = `/v1/userRegister/queryOptionList`;
      this.catReq1Service(url, {
        dataType: "domain"
      }).then(function (response) {
        that.domainList = response.result
        that.domainList.unshift({
          dataValue: "全领域",
          dataDesc: "全领域",
          dataType: 'allCode',
          id: 10086,
        })
      })
    },
    //领域
    handeleDomainCode (e) {
      let that = this
      that.domainCodeList = []
      // console.log(that.domainList)
      that.domainList.forEach(item => {

        if (item.dataValue == that.FormDataOne.domainCode) {
          let obj = {}
          obj.domainCode = item.dataKey
          obj.domainName = item.dataDesc
          obj.userId = that.userId
          obj.id = item.id
          that.domainCodeList.push(obj)
        }
      })

      // console.log(that.domainCodeList)
    },
    goEssentialInformation () {
      this.isDis = false
    },
    async preservation () {
      let verify = true;
      const formList = ["companyName", "companyAddress", "establishTime", "companyUrl", "companyType", "companyScale", "domainCode", "taxpayerId"]
      this.$refs.ruleFormDataOne.validateField(formList, errTip => {
        if (errTip) {
          // 会调用多次
          verify = false;
        }
      })
      if (verify) {
        let url = "/v1/userRegister/add_or_update_company_register_info"
        let myUser = JSON.parse(localStorage.getItem("myUser"))
        if (!this.certificateUrls) {
          this.certificateUrls = []
        }
        if (!this.domainCodeList) {
          this.domainCodeList = []
        }
        let params = {
          id: this.id,
          auditStatus: this.auditStatus === 0 ? 0 : 2,
          userId: myUser.id,
          companyName: this.FormDataOne.companyName,
          companyAddress: this.FormDataOne.companyAddress,
          establishTime: this.FormDataOne.establishTime,
          companyUrl: this.FormDataOne.companyUrl,
          companyType: this.FormDataOne.companyType,
          companyScale: this.FormDataOne.companyScale,
          domainCode: this.domainCodeList.length === 0 ? "" : this.domainCodeList[0].domainCode,
          domainName: this.domainCodeList.length === 0 ? "" : this.domainCodeList[0].domainName,
          taxpayerId: this.FormDataOne.taxpayerId,
          businessLicenseUrls: this.certificateUrls
        }

        const res = await this.catReq1Service(url, params)
        if (res.resultCode === "1") {
          this.isDis = true;
          this.$emit("succe", res.result)
        }
      }
    },
    cancel () {
      this.$refs['ruleFormDataOne'].clearValidate();
      this.FormDataOne = { ...this.dataObj }
      this.isDis = true;
    },
  },
};
</script>

<style lang="less" scoped>
.essential_information {
  .tabs {
    display: flex;
    font-size: 16px;
    align-items: center;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(28, 28, 29, 1);
    margin-bottom: 20px;
    span {
      width: 4px;
      height: 16px;
      background: rgba(30, 134, 230, 1);
      margin-right: 5px;
    }
    .tabs_one {
      display: inline-block;
      cursor: pointer;
      width: 16px;
      height: 16px;
      background: url("../../assets/imgs/authentication/modify_normal.png")
        no-repeat;
      background-size: cover;
      margin-left: 10px;
      &:active {
        background: url("../../assets/imgs/authentication/modify_press.png")
          no-repeat;
      }
    }
  }
  .el-form {
    display: flex;
    flex-wrap: wrap; //flex-grow
    .el-form-item {
      width: 40%;
    }
    .el-input {
      width: 202px;
    }
    /deep/.el-select {
      .el-input {
        width: 202px;
      }
    }
  }
  .btn {
    width: 100%;
    text-align: right;
    .el-button {
      width: 80px;
      height: 36px;
      box-sizing: border-box;
      font-family: Microsoft YaHei;
      font-size: 16px;
      line-height: 0;
    }
    .cancel {
      background: rgba(219, 239, 255, 1);
      border: 1px solid rgba(30, 134, 230, 1);
      box-shadow: 0px 3px 8px 0px rgba(153, 153, 153, 0.5);
      border-radius: 4px;
    }
    .preservation {
      background: rgba(30, 134, 230, 1);
      box-shadow: 0px 3px 8px 0px rgba(30, 134, 230, 0.5);
      border-radius: 4px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      margin-left: 50px;
    }
  }
}
</style>
